export default function Map() {
  return (
    <div className="w-screen flex justify-center pb-32">
      <div className="w-full max-w-[1280px] px-8">
        <div className="flex flex-col gap-8">
          <h2 className="headline-large">Encuéntranos en CDMX:</h2>
          <div className="w-full h-[500px] rounded-2xl overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.2773837793765!2d-99.19699492376676!3d19.411552740870277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d201f993e08b05%3A0x4c9b1b47f7bf1f0e!2sSur%20136%2024%2C%20Am%C3%A9rica%2C%20Miguel%20Hidalgo%2C%2011820%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX%2C%20Mexico!5e0!3m2!1sen!2sus!4v1711170645830!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 